import { createClient } from "@sanity/client";

export default createClient({
  projectId: "t1fyqxkx",
  dataset: "production",
  useCdn: false,
  apiVersion: "2023-03-08",
});
